<template>
    <div class="main">
        <c-panel title="CONCEITOS HIERÁRQUICOS" titleIcon="fas fa-sitemap">
            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.grupo_conceito_id" placeholder="Filtrar por grupo" clearable @change="load">
                        <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="10">
                    <el-input v-model="filtro.descricao" placeholder="Pesquisar descrição..." @keyup.native.enter="load"></el-input>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link to="/admin/conceito/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO CONCEITO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 70px;">Cod</th>
                            <th>Grupo</th>
                            <th>Descrição</th>
                            <th style="width: 80px;">Ordem</th>
                            <th style="width: 90px;">Itens</th>
                            <th style="width: 110px;" class="u-text-center">Situação</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="status">
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ item.id }}</td>
                            <td>{{ item.grupo ? item.grupo.nome : '—' }}</td>
                            <td>{{ item.descricao }}</td>
                            <td>{{ item.ordem }}</td>
                            <td>{{ Array.isArray(item.itens) ? item.itens.length : 0 }}</td>
                            <td class="u-text-center">{{ item.situacao ? 'Ativo' : 'Inativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/conceito/edit/' + item.id" class="link-icon u-mr-10">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="7" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum conceito encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!status" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        status: false,
        grupos: [],
        filtro: { grupo_conceito_id: '', descricao: '' },
        items: []
    }),
    mounted () {
        this.carregarGrupos()
        this.load()
    },
    methods: {
        carregarGrupos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/grupo-conceito/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.grupos = r.data || [] })
        },
        load () {
            this.status = false
            this.items = []
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/conceito/getAllPaginate`,
                this.filtro,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = (r.data && r.data.data) || []
                this.status = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluir (id) {
            this.$msgbox.confirm('Excluir este conceito?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/conceito/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(() => {
                    window.eventBus.$emit('alert', { msg: 'Excluído.', type: 'success' })
                    this.load()
                })
            }).catch(() => {})
        }
    }
}
</script>
